import type { FC } from 'react'
import ListHeader, { ListHeaderProps } from '@/components/molecules/listHeader'
import { Box } from '@/components/atoms/Grid'
import type { BridgeProduct } from 'types/bridgeProduct'
import { Translate } from 'next-translate'
import useTranslation from 'next-translate/useTranslation'
import { withProductDetailPopup } from '@/HOC/withProductDetailPopup'
import type { ShowProductModal } from '@/HOC/withProductDetailPopup'
import { FilteredBy } from '@/components/organisms/filter'
import ProductsContainer from './productsContainer'
import type { ListingData } from 'types/listingData'
import { CategoryType } from 'types/categoryType'
import type { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import BannersLayout, { BannersType, PreloadMode } from './bannersLayout'
import { RecommendedIconDefault } from '../atoms/icons/RecommendedIconDefault'

type CategoryProductsContainerProps = {
  data: ListingData<BridgeProduct>
  showProductModal?: ShowProductModal
  showFilteredBy?: boolean
  showPager?: boolean
  productListingFetcher: ProductListingFetcher
  list: string
} & Rest

const CategoryProductsContainer: FC<CategoryProductsContainerProps> = ({
  data,
  showProductModal,
  showFilteredBy = false,
  showPager = false,
  productListingFetcher,
  list,
  ...rest
}) => {
  const { t } = useTranslation('common')
  return (
    <Box
      textAlign="center"
      flex="1"
      data-cy="productListingContainer"
      {...rest}
    >
      {showFilteredBy && (
        <FilteredBy
          mb={20}
          display={{ mobile: 'none', tablet: 'none', desktop: 'flex' }}
        />
      )}
      {data?.banners?.length ? (
        <BannersLayout
          banners={data.banners}
          gridColumnGap={15}
          mb={{ desktop: 50, tablet: 40, mobile: 20 }}
          bannerDst={BannersType.MainCategory}
          preload
          preloadMode={PreloadMode.First}
        />
      ) : null}
      {data.type !== undefined && (
        <ListHeader {...makeCategoryListHeader(data.type, t)} />
      )}
      <ProductsContainer
        fetcher={productListingFetcher}
        data={data}
        action={showProductModal}
        showPager={showPager}
        list={list}
      />
    </Box>
  )
}

export default withProductDetailPopup(CategoryProductsContainer)

const makeCategoryListHeader = (
  type: CategoryType,
  t: Translate
): ListHeaderProps => {
  switch (type) {
    case CategoryType.maybeInterestedIn:
      return {
        title: t('Category.YouMayLike.title'),
        description: {
          IconElement: RecommendedIconDefault,
          text: t('Category.YouMayLike.description')
        }
      }
  }
}
